"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CELL_VALUE_CATEGORY_KEY = 'base';
exports.CELL_VALUE_PARENT_COMPONENT_KEY = 'table';
exports.CELL_VALUE_COMPONENT_KEY = 'cellValue';